import LicenceTreeBase from 'pages/services/serviceprofiles/edit/formFields/LicenceTreeBase';

/**
 * LicenceEntitlementsTree
 *
 * Dashboard entitlements wizard — status + volume mode.
 * No FormLabel wrapper (the parent page provides its own heading).
 */
const LicenceEntitlementsTree = ({
    catalogue,
    value,
    onChange,
    darkMode,
    hasActive,
    activeMap,
    isReadOnly,
    hasVolume = true,
}) => (
    <LicenceTreeBase
        catalogue={catalogue}
        value={value}
        onChange={onChange}
        darkMode={darkMode}
        hasVolume={hasVolume}
        showFormLabel={false}
        hasActive={hasActive}
        activeMap={activeMap}
        isReadOnly={isReadOnly}
    />
);

export default LicenceEntitlementsTree;
